import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-device-restriction-dialog',
  templateUrl: './device-restriction-dialog.component.html',
  styleUrls: ['./device-restriction-dialog.component.scss']
})
export class DeviceRestrictionDialogComponent {

  languague: any;

  constructor( 
    public dialogRef: MatDialogRef<DeviceRestrictionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public devices,
    private userServise: UserService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translateService: TranslateService
    ) {
      this.languague = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
      this.translateService.use(this.languague);
    }

    onSignOutDevice(device) {
      this.userServise.signOutDevice(this.devices.uid, [device.id],this.devices?.signInData?.devid, this.devices?.deviceName).subscribe((res: any) => {
        res.deviceList = res?.deviceList?.filter(device => device?.id !=this.devices?.signInData?.devid)
        this.devices.deviceDetails = res;
        if(this.devices?.deviceDetails?.deviceList?.length -1 < this.devices?.deviceDetails?.device_limit) {
          this.dialogRef.close(true);
          localStorage.setItem('allow_Signin', 'true');
          this.setTheAuthToken(res.authToken);

        }

      }, (_error) => {
        this.openSnackBar('Something went wrong. Please try again', '');
      });
    }

    setTheAuthToken(res) {
        let user = JSON.parse(localStorage.getItem("user"));
        user.token = res;
        localStorage.setItem("user", JSON.stringify(user));
    }

    onSignOutAllDevices() {
      const ids = [];
      this.devices?.deviceDetails?.deviceList?.forEach(device => {
        ids.push(device.id)
      })
      this.userServise.signOutDevice(this.devices.uid, ids,this.devices?.signInData?.devid, this.devices?.deviceName).subscribe((res: any) => {
        localStorage.setItem('allow_Signin', 'true');
          this.setTheAuthToken(res.authToken);
        this.dialogRef.close(true);
      },
       (_error) => {
        this.openSnackBar('Something went wrong. Please try again', '');
      })
    }

    onBackToLogin() {
      this.userServise.signOutOfApp();
      this.dialogRef.close();
    }

    getDate(date) {
        return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD, MMM yyyy, h:mm a");
    }

    openSnackBar(message: string, action: string) {
      this.snackBar.open(message, action, {
        duration: 2000,
      });
    }


}
